<template>
  <el-table-column
    :prop="prop"
    :width="width"
    :min-width="minWidth"
    :align="align"
    :fixed="fixed"
    label-class-name="table-header"
  >
    <template slot="header" slot-scope="{}">
      <span :title="title">{{ title }}</span>
    </template>

    <template v-slot:default="scope">
      <slot
        name="default"
        v-bind="scope"
        :rowValue="rowValue"
        :rowRoute="rowRoute"
      >
        <iframe
          :srcdoc="iframeContent(scope)"
          style="border: 1px solid #EBEEF5;"
          height="auto"
          width="100%"
        />
      </slot>
    </template>
  </el-table-column>
</template>

<script>
import _ from 'lodash'

export default {
  name: 'RestListColumnIFrame',

  inject: {
    restList: 'restList'
  },

  props: {
    prop: {
      type: String,
      required: true
    },

    title: {
      type: String,
      required: true
    },

    route: {
      type: Function,
      required: false
    },

    formatter: {
      type: Function,
      required: false,
      default: value => {
        return value || '-'
      }
    },

    fixed: {
      type: Boolean,
      required: false,
      default: false
    },

    width: {
      type: Number,
      required: false
    },

    minWidth: {
      type: Number,
      required: false
    },

    align: {
      type: String,
      required: false
    }
  },

  methods: {
    rowRoute(row) {
      if (this.route) {
        return this.route(row)
      } else {
        return null
      }
    },

    rowValue(scope) {
      return this.formatter(_.get(scope.row, this.prop), scope.row)
    },

    iframeContent(scope) {
      return this.rowValue(scope)
    }
  }
}
</script>
<style scoped>
>>> p {
  font-weight: normal !important;
  font-size: unset !important;
  line-height: unset !important;
  color: unset !important;
}
</style>



// WEBPACK FOOTER //
// src/common/components/rest/RestListColumnIFrame.vue